import React from 'react';
import { Button } from './ui/button';
import { Sparkles, Award, Clock } from 'lucide-react';

const Hero = () => {
  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Ultra Luxury Gradient Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-[#0a0604] to-black"></div>
        <div className="absolute top-20 left-10 w-[500px] h-[500px] bg-[#c9a961]/8 rounded-full blur-[140px]"></div>
        <div className="absolute bottom-20 right-10 w-[600px] h-[600px] bg-[#8b6f3e]/8 rounded-full blur-[160px]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 grid lg:grid-cols-2 gap-16 items-center">
        {/* Left Content */}
        <div className="space-y-10">
          <div className="inline-flex items-center space-x-3 bg-gradient-to-r from-[#c9a961]/10 to-transparent border border-[#c9a961]/40 px-6 py-3 backdrop-blur-sm">
            <Sparkles className="text-[#c9a961]" size={20} />
            <span className="text-[#c9a961] text-sm font-medium tracking-[0.15em] uppercase">New Clients Get 15% Off - CODE: PREP15</span>
          </div>

          <h1 className="font-['Playfair_Display'] text-6xl md:text-7xl font-light text-[#f8f6f0] leading-[1.1]">
            The Sun-Kissed
            <span className="block bg-gradient-to-r from-[#c9a961] via-[#d4af37] to-[#c9a961] bg-clip-text text-transparent mt-3">Balayage Vancouver</span>
            <span className="block text-[#f8f6f0] mt-3">Locals Actually Love</span>
          </h1>

          <p className="text-[#f8f6f0]/70 text-xl leading-relaxed max-w-xl">
            Vancouver's most trusted balayage specialists at Prép Beauty Parlour — Downtown Vancouver's home for hand-painted California, blonde, and brunette balayage. Colour that grows beautifully, lasts longer, and looks effortlessly natural.
          </p>

          <div className="flex flex-wrap gap-10 pt-6">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#c9a961]/20 to-transparent border border-[#c9a961]/30 flex items-center justify-center">
                <Award className="text-[#c9a961]" size={28} />
              </div>
              <div>
                <div className="text-3xl font-bold text-[#f8f6f0]">400+</div>
                <div className="text-sm text-[#f8f6f0]/60 tracking-wide">5-Star Reviews</div>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#c9a961]/20 to-transparent border border-[#c9a961]/30 flex items-center justify-center">
                <Clock className="text-[#c9a961]" size={28} />
              </div>
              <div>
                <div className="text-3xl font-bold text-[#f8f6f0]">2.5-4hrs</div>
                <div className="text-sm text-[#f8f6f0]/60 tracking-wide">Session Duration</div>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-5 pt-6">
            <Button
              data-testid="hero-book-cta"
              onClick={() => window.open('https://www.fresha.com/a/prep-beauty-parlour-vancouver-1305-burrard-street-hlh2s5oh', '_blank')}
              className="bg-gradient-to-r from-[#c9a961] to-[#8b6f3e] hover:from-[#d4af37] hover:to-[#c9a961] text-black font-semibold px-10 py-7 text-lg rounded-none transition-all duration-500 hover:shadow-[0_0_50px_rgba(201,169,97,0.5)] hover:scale-105"
            >
              Book My Session
            </Button>
            <Button
              data-testid="hero-explore-services"
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              className="border-2 border-[#c9a961] text-[#c9a961] hover:bg-[#c9a961] hover:text-black font-semibold px-10 py-7 text-lg rounded-none transition-all duration-500 hover:shadow-[0_0_30px_rgba(201,169,97,0.3)]"
            >
              Explore Services
            </Button>
          </div>
        </div>

        {/* Right Video */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-[#c9a961]/20 to-transparent rounded-none blur-3xl"></div>
          <div className="relative overflow-hidden shadow-[0_20px_80px_rgba(201,169,97,0.2)] border border-[#c9a961]/30">
            <video
              data-testid="hero-video"
              src="https://customer-assets.emergentagent.com/job_luxury-locks-4/artifacts/p1ydqnzl_Yohan-Pre%CC%81p%20Beauty-Vancouver-Balayage.mp4"
              className="w-full h-[650px] object-cover"
              autoPlay
              muted
              loop
              playsInline
              aria-label="Yohan performing balayage hair coloring technique at Prép Beauty Parlour in Vancouver"
              title="Expert Balayage Transformation by Yohan - Prép Beauty Parlour Vancouver"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
